import React from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { RoutePath } from '@/routes'

import { BeautyButton } from './common/Button'
import { Text } from './common/Text'
import { IconCreate } from './svgr/create'

const CreateToken: React.FC<{
  className?: string
  wrapperClassName?: string
}> = ({ wrapperClassName, className }) => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  return (
    <BeautyButton
      wrapperClassName={wrapperClassName}
      className={className}
      onClick={() => navigate(RoutePath.CREATE)}
    >
      <IconCreate />
      <Text className="font-semibold">{t('create.tabCreateCoin')}</Text>
    </BeautyButton>
  )
}

export default CreateToken
